import { z } from 'zod';

export const moduleDtoSchema = z.object({
  id: z.string().uuid(),
  code: z.string().max(50),
  name: z.string().max(100),
  description: z.string().max(500).nullable(),
  active: z.boolean(),
  createdAt: z.string().datetime(),
});

export const moduleDtoListSchema = z.array(moduleDtoSchema);

export type ModuleDto = z.infer<typeof moduleDtoSchema>;
